import { render, staticRenderFns } from "./CRPDF.vue?vue&type=template&id=48441c82"
import script from "./CRPDF.vue?vue&type=script&lang=js"
export * from "./CRPDF.vue?vue&type=script&lang=js"
import style0 from "./CRPDF.vue?vue&type=style&index=0&id=48441c82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports